<template>
  <div class="schedule_wamp">
    <!-- 订单进度 -->
    <div class="schedule">
      <div v-for="(value, index) in header" :key="index" class="wamp">
        {{ value }}
      </div>
    </div>
    <div class="item_wamp_li">
      <ul class="scroll_ul">
        <li v-for="(item, i) in list" :key="i" class="li_wamp">
          <div class="wamp" v-for="(value, index) in item" :key="index">
            {{ value }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderSchedule",
  data() {
    return {
      header: [],
      list: [],
      height: 0, // 滚动的距离
    };
  },
  mounted() {
    let timer = setInterval(() => {
      if (this.$url.length > 0) {
        clearInterval(timer);

        this.$axios
          .get(`${this.$url}${this.$apiObj.orderSchedule}`)
          .then((res) => {
            let datas = res.data.data;
            this.header = datas.cols.map((item) => item.display_name);
            this.list = datas.rows;
          });

        setInterval(() => {
          this.scroll();
        }, 1000);
      }
    }, 1000);
  },
  methods: {
    scroll() {
      // 滚动
      let scroll_ul = document.querySelectorAll(".scroll_ul")[0];
      let li_wamp_height =
        document.querySelectorAll(".li_wamp")[0].clientHeight; // 高度 每一次滚动的距离
      if (this.height > scroll_ul.clientHeight - 100) {
        this.$axios
          .get(`${this.$url}${this.$apiObj.orderSchedule}`)
          .then((res) => {
            let datas = res.data.data;
            this.header = datas.cols.map((item) => item.display_name);
            this.list = datas.rows;
            this.height = 0;
          });
      }
      this.height += li_wamp_height;
      scroll_ul.style.transform = `translate3d(0 , ${-this.height}px , 0)`;
    },
  },
};
</script>

<style lang="less">
.schedule_wamp {
  height: 100%;
  .schedule {
    display: flex;
    .wamp {
      color: white;
      font-size: 1.5rem;
      padding: 0.625rem;
      text-align: leftt;
    }
    .wamp:nth-child(1),
    .wamp:nth-child(2) {
      flex: 1;
    }
    .wamp:nth-child(3) {
      flex: 8;
    }
  }
  .item_wamp_li {
    overflow: hidden;
    height: 80%;
    .scroll_ul {
      transition: all 2s;
      .li_wamp {
        display: flex;
        .wamp {
          color: white;
          font-size: 1rem;
          padding: 0.625rem;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .wamp:nth-child(1),
        .wamp:nth-child(2) {
          flex: 1;
        }
        .wamp:nth-child(3) {
          flex: 8;
        }
      }
    }
  }
}
</style>